import React from "react"

import useSubscriptionLimits from "@/hooks/useSubscriptionLimits"
import useModules from "@/hooks/useModules"

import UpsellPage from "@/components/UpsellPage"
import { Loading } from "@/components"

import MessageBlastList from "@/pages/Admin/MessageBlast/MessageBlastList"

import MessageBlastSkeleton from "@/skeletons/Admin/MessageBlast"
import { useGlobalStateStore } from "@/store/GlobalState"

const MessageBlast: React.FC = () => {
	const globalStateStore = useGlobalStateStore()
	const isWabaChannel = globalStateStore.currentChannel?.channelType === "waba"

	const messageBlastSubscriptionData = useSubscriptionLimits("permission", "messageBlast", {
		modalLimitsOptions: {
			openModalWhenHasNoPermission: !isWabaChannel,
			onSaveReturnToLastPage: true
		}
	})

	const { isModulePermission, loading } = useModules("message-blast")

	const messageBlastModuleIsEnabled = !messageBlastSubscriptionData.mustBlock && isModulePermission

	const shouldShowUpsellPage = messageBlastModuleIsEnabled || isWabaChannel

	return (
		<Loading
			loading={loading}
			customLoadingElement={<MessageBlastSkeleton />}
		>
			{!shouldShowUpsellPage ? <UpsellPage feature="message-blast" /> : <MessageBlastList />}
		</Loading>
	)
}

export default MessageBlast
